function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.string.bold.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import visit from 'unist-util-visit';
import { assert } from "../../utils";
import { isArray } from "../../utils/isArray";
var srOnlyStyle = 'border: 0; clip: rect(0,0,0,0); height: 1px; margin: -1px; overflow: hidden; padding: 0; position: absolute; white-space: nowrap; width: 1px;';
/**
 * This is a custom rehype plugin that truncates the markdown content to the
 * specified number of displayed characters.
 *
 * @note Ths function was copied from [here](https://github.com/luk707/rehype-truncate/blob/master/src/index.js) with a few changes
 * 1. It was changed to typescript
 * 2. Unused options were removed
 * 3. Options were added to support a "See more" link
 *
 * We chose not to install and use the rehype plugin directly, because:
 * 1. It has a low score on snyk (48/100) as of writing
 * 2. It's a small function to copy here
 * 3. Copying it allows us to easily add the "See more" link option
 */
export function rehypeTruncate() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    truncationSettings = _ref.truncationSettings,
    _ref$truncated = _ref.truncated,
    truncated = _ref$truncated === void 0 ? false : _ref$truncated;
  var ellipses = "\u2026";
  var _ref2 = truncationSettings || {},
    maxChars = _ref2.maxChars,
    _ref2$seeMoreText = _ref2.seeMoreText,
    seeMoreText = _ref2$seeMoreText === void 0 ? 'See more' : _ref2$seeMoreText,
    _ref2$seeLessText = _ref2.seeLessText,
    seeLessText = _ref2$seeLessText === void 0 ? 'See less' : _ref2$seeLessText,
    _ref2$srOnlyText = _ref2.srOnlyText,
    srOnlyText = _ref2$srOnlyText === void 0 ? '' : _ref2$srOnlyText;
  return truncator;
  function truncator(tree) {
    if (typeof maxChars !== 'number') return;
    if (!truncated) {
      addSeeLessButton(tree, {
        seeLessText: seeLessText,
        srOnlyText: srOnlyText
      });
      return;
    }
    truncateNode(tree);
  }

  /**
   * Truncates the node to the specified number of characters, and adds a "See
   * more" button
   */
  function truncateNode(node) {
    var startingNumCharsFound = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    assert(typeof maxChars === 'number');
    var numCharsFound = startingNumCharsFound;
    if (node.type === 'text') {
      numCharsFound += node.value.length;
      if (numCharsFound >= maxChars) {
        node.value = node.value.slice(0, node.value.length - (numCharsFound - maxChars));
        return {
          endingFoundChars: maxChars,
          truncatedText: true
        };
      }
    }
    if (node.type === 'root' || node.type === 'element') {
      var truncatedText = false;
      for (var i = 0; i < node.children.length; i++) {
        if (numCharsFound >= maxChars) {
          node.children.splice(i, 1);
          i--;
          continue;
        }
        var result = truncateNode(node.children[i], numCharsFound);
        numCharsFound = result.endingFoundChars;
        truncatedText = result.truncatedText;
      }
      if (truncatedText) {
        var linkTextChild = {
          type: 'text',
          value: seeMoreText
        };
        var linkTextSrOnlyChild = {
          tagName: 'span',
          type: 'element',
          children: [{
            type: 'text',
            value: " ".concat(srOnlyText)
          }],
          properties: {
            style: srOnlyStyle
          }
        };
        appendInline(node, {
          tagName: 'span',
          type: 'element',
          children: [{
            type: 'text',
            value: "".concat(ellipses, " ")
          }]
        });
        appendInline(node, {
          tagName: 'button',
          type: 'element',
          children: srOnlyText ? [linkTextChild, linkTextSrOnlyChild] : [linkTextChild]
        });
      }
    }
    return {
      endingFoundChars: numCharsFound,
      truncatedText: false
    };
  }
}

/**
 * Tries to append a "See less" button to the last child.  If we can't append
 * to the last child, then it appends to the root
 */
function addSeeLessButton(tree, _ref3) {
  var seeLessText = _ref3.seeLessText,
    srOnlyText = _ref3.srOnlyText;
  var seeLessTextNode = {
    type: 'text',
    value: seeLessText
  };
  var srOnlyNode = {
    tagName: 'span',
    type: 'element',
    children: [{
      type: 'text',
      value: " ".concat(srOnlyText)
    }],
    properties: {
      style: srOnlyStyle
    }
  };
  var buttonNode = {
    tagName: 'button',
    type: 'element',
    children: srOnlyText ? [seeLessTextNode, srOnlyNode] : [seeLessTextNode]
  };
  var spanWrapper = {
    tagName: 'span',
    type: 'element',
    children: [{
      type: 'text',
      value: ' '
    }, buttonNode]
  };
  appendInline(tree, spanWrapper);
}

/**
 * Appends an inline element to the rehype (aka hast) tree
 */
export function appendInline(tree, element) {
  var lastParent = getLastNodeParent(tree);

  // For some reason, react-markdown puts newlines between list items like this:
  // ```json
  // {
  //   tagName: 'ul',
  //   children: [
  //     { type: 'text', value: '\n' },
  //     { tagName: 'li', children: [ { type: 'text', value: 'Item 1' } ] },
  //     { type: 'text', value: '\n' },
  //   ]
  // }
  // ```
  // This messes up our logic, because we want to append to the last list item,
  // but due to the last `{ type: 'text', value: '\n' }`, `getLastNodeParent()`
  // finds the `ul` instead of the `li`
  //
  // So we need special handling for `ul` / `ol`
  //
  // If the last parent is a `ul` or `ol`, we try to (recursively) append to the
  // last `li` instead of to the `ul`
  //
  if ('tagName' in lastParent && (lastParent.tagName === 'ul' || lastParent.tagName === 'ol')) {
    var lastUlChild = lastParent.children[lastParent.children.length - 1];
    var lastLi = lastParent.children[lastParent.children.length - 2];
    if (lastUlChild && lastUlChild.type === 'text' && lastUlChild.value === '\n' && lastLi && 'tagName' in lastLi && lastLi.tagName === 'li') {
      appendInline(lastLi, element);
      return;
    }
    lastParent.children.push({
      type: 'element',
      tagName: 'li',
      children: [element]
    });
    lastParent.children.push({
      type: 'text',
      value: '\n'
    });
    return;
  }
  lastParent.children.push(element);
}

/**
 * Gets the parent of the last node in a tree
 */
function getLastNodeParent(root) {
  var _ref4 = getLastNodeAndItsParent(root) || {},
    parent = _ref4.parent;
  return parent || root;
}

/**
 * Gets the last node in the tree and its parent
 *
 * Returns undefined if there is no last node
 */
function getLastNodeAndItsParent(root) {
  var lastChild = root.children[root.children.length - 1];
  if (!lastChild) {
    return undefined;
  }
  if ('children' in lastChild && isArray(lastChild.children)) {
    var lastNodeInfo = getLastNodeAndItsParent(lastChild);
    if (lastNodeInfo) {
      return lastNodeInfo;
    }
  }
  return {
    node: lastChild,
    parent: root
  };
}
/**
 * This is a custom rehype plugin that adds a property to blockquotes
 * indicating the type of alert they represent.
 *
 * @see https://github.com/orgs/community/discussions/16925
 */
export function rehypeAlert() {
  return transformer;
  function transformer(tree) {
    visit(tree, 'element', function (node) {
      if (!node.properties || _typeof(node.properties) !== 'object') {
        return;
      }
      var textNode = getBlockquoteTextNode(node);
      if (!textNode) {
        return;
      }
      assert(typeof textNode.value === 'string');
      var importanceMatch = textNode.value.match(/^\s*\[!(NOTE|TIP|WARNING|CAUTION)\](\n)?/i);
      if (!(importanceMatch !== null && importanceMatch !== void 0 && importanceMatch[0])) {
        return;
      }
      var importance = importanceMatch[0].toLowerCase().trim().replace('[!', '').replace(']', '').replace('\n', '');
      textNode.value = textNode.value.replace(importanceMatch[0], '');
      Object.assign(node.properties, {
        className: importance
      });
    });
  }
  function getBlockquoteTextNode(node) {
    if ('tagName' in node && 'children' in node && node.tagName === 'blockquote' && isArray(node.children) && 'properties' in node && _typeof(node.properties) === 'object' && node.properties) {
      var firstChild = node.children[1];
      if (_typeof(firstChild) === 'object' && firstChild && 'tagName' in firstChild && firstChild.tagName === 'p') {
        if ('children' in firstChild && isArray(firstChild.children)) {
          var firstGrandChild = firstChild.children[0];
          if (firstGrandChild && _typeof(firstGrandChild) === 'object' && 'type' in firstGrandChild && firstGrandChild.type === 'text' && 'value' in firstGrandChild && typeof firstGrandChild.value === 'string') {
            return firstGrandChild;
          }
        }
      }
    }
  }
}
/**
 * Validates the heading styles to ensure they are accessible.
 *
 * @param config - The configuration object containing the heading styles
 *
 * This function checks the heading styles configuration and ensures that:
 * - The keys in the styles object are valid heading tags ('h1' to 'h6').
 * - If the style variant is 'bodyM', it must have a contrast of 'mid' and bold
 *   set to true.  This is to ensure that the heading has enough visual
 *   difference from the body text
 * - If the style variant is not 'bodyM', it should not have 'contrast' or
 *   'bold' properties.
 *
 * @throws Will throw an error if any of the validation rules are violated.
 */
export function validateAccessibleHeadingStyles(config) {
  if (!(config !== null && config !== void 0 && config.styles)) return;
  for (var key in config.styles) {
    assert(key === 'h1' || key === 'h2' || key === 'h3' || key === 'h4' || key === 'h5' || key === 'h6', 'Invalid heading style key');
    var style = config.styles[key];
    if ((style === null || style === void 0 ? void 0 : style.variant) === 'bodyM') {
      if (style.contrast !== 'mid' || style.bold !== true) {
        throw new Error("Heading style for ".concat(key, " with variant \"bodyM\" must have contrast \"mid\" and bold true"));
      }
    } else {
      if (style && ('contrast' in style || 'bold' in style)) {
        throw new Error("Heading style for ".concat(key, " can only have contrast and bold when variant is \"bodyM\""));
      }
    }
  }
}